import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center min-h-0" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/ _createTextVNode("+");
const _hoisted_5 = { class: "flex flex-col p-2 mt-4 bg-teal-100 border border-teal-600 rounded-sm w-101 dark:bg-gray-600 dark:border-gray-500" };
const _hoisted_6 = { class: "text-teal-600 text-sm-but-a-bit-smaller dark:text-white" };
const _hoisted_7 = { class: "font-bold" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.new_retro.participants_picker')
};
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useSeatsValidations } from '@/composables/seatsValidations';
import { isInvitation } from '@/types/workspaces';
import { isUnknownUser, isUser } from '@/types/user';
import Drawer from '@/components/Drawer.vue';
import DrawerEndingButton from '@/components/DrawerEndingButton.vue';
import MemberDrawerItem from '@/components/MemberDrawerItem.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import InvitesAndSeatsModal from '@/components/workspaces/InvitesAndSeatsModal.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'ParticipantsPicker',
    setup(__props) {
        const store = useStore();
        const isLoading = ref(false);
        const searchTerm = ref('');
        const seatsToBuy = ref(0);
        const workspace = computed(() => store.getters.workspace);
        const team = computed(() => store.getters.team);
        const singleTeamInvitations = computed(() => {
            const invites = team.value.invitations;
            const pairs = invites.map((i) => [i.email, i]);
            const map = new Map(pairs);
            return Array.from(map.values());
        });
        const sessionId = computed(() => store.getters.session.id);
        const members = computed(() => team.value.members);
        const participantIds = computed(() => store.state.newRetro.participantIds);
        onMounted(() => {
            singleTeamInvitations.value.forEach((p) => inviteSelections.value.push(p));
        });
        const restWorkspaceMembers = computed(() => {
            if (!workspace.value.members) {
                return [];
            }
            const teamEmails = new Set(members.value.map((m) => m.email));
            return workspace.value.members.filter((m) => !teamEmails.has(m.email));
        });
        const sortedMembers = computed(() => {
            return members.value
                .filter((m) => m.id !== sessionId.value)
                .sort((m1, m2) => m1.name.localeCompare(m2.name));
        });
        const me = computed(() => {
            return members.value.find((m) => m.id === sessionId.value);
        });
        const moderatorParticipates = computed(() => {
            return store.getters['newRetro/moderatorParticipates'];
        });
        const pendingInvites = computed(() => store.getters['newRetro/pendingParticipants']);
        const counterValue = computed(() => {
            const selectedCount = participantIds.value.size + inviteSelections.value.length;
            const membersCount = members.value.length + inviteSelections.value.length;
            return `${selectedCount}/${membersCount}`;
        });
        const isInviteModalVisible = ref(false);
        const modalInvites = ref([]);
        const inviteSelections = computed({
            get() {
                return store.state.newRetro.invitedUsers;
            },
            set(users) {
                store.commit('newRetro/updateInvitedUsers', users);
            }
        });
        const teamInvitations = computed(() => {
            return inviteSelections.value.filter((i) => isInvitation(i));
        });
        const invitedUnknownUsers = computed(() => {
            return inviteSelections.value.filter((u) => isUnknownUser(u));
        });
        const invitedUsers = computed(() => {
            return inviteSelections.value.filter((u) => isUser(u));
        });
        const { hasToBuySeats } = useSeatsValidations({
            selectedUsers: computed(() => [...modalInvites.value, ...inviteSelections.value]),
            searchTerm,
            seatsToBuy,
            workspace
        });
        function toggleInviteModalVisibility() {
            isInviteModalVisible.value = !isInviteModalVisible.value;
        }
        function handleRemoveInvitedUnknownUser(user) {
            const index = inviteSelections.value.findIndex((u) => isUnknownUser(u) && u.email === user.email);
            inviteSelections.value.splice(index, 1);
        }
        function handleRemoveInvitedUser(user) {
            const index = inviteSelections.value.findIndex((u) => isUser(u) && u.id === user.id);
            inviteSelections.value.splice(index, 1);
        }
        function handleParticipantChange(id) {
            if (participantIds.value.has(id)) {
                store.commit('newRetro/removeParticipantId', id);
            }
            else {
                store.commit('newRetro/addParticipantId', id);
            }
        }
        function handleTeamInvitationChange(invitation) {
            const index = inviteSelections.value.findIndex((i) => i.email === invitation.email);
            const inviteSelections2 = [...inviteSelections.value];
            if (index !== -1) {
                inviteSelections2.splice(index, 1);
                inviteSelections.value = inviteSelections2;
            }
            else {
                inviteSelections2.push(invitation);
                inviteSelections.value = inviteSelections2;
            }
        }
        async function handleSendInvites() {
            if (workspace.value?.plan === 'pro' && hasToBuySeats.value) {
                isLoading.value = true;
                const totalSeats = workspace.value.seats + seatsToBuy.value;
                await store.dispatch('updateWorkspace', {
                    seats: totalSeats,
                    workspaceId: workspace.value.id
                });
                isLoading.value = false;
            }
            if (modalInvites) {
                inviteSelections.value = [...inviteSelections.value, ...modalInvites.value];
                modalInvites.value = [];
                toggleInviteModalVisibility();
            }
        }
        function handleCancelInvites() {
            modalInvites.value = [];
            toggleInviteModalVisibility();
        }
        function handleModeradorParticipationChange(value) {
            store.dispatch('newRetro/updateModeratorParticipation', value);
        }
        return (_ctx, _cache) => {
            const _component_CheckboxField = _resolveComponent("CheckboxField");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Drawer, {
                    class: "flex-1 min-h-0 w-101",
                    icon: "participants",
                    count: _unref(counterValue),
                    title: _ctx.$t('drawer_title'),
                    collapsible: false
                }, {
                    "fixed-bottom": _withCtx(() => [
                        _createVNode(DrawerEndingButton, {
                            class: "flex-shrink-0",
                            onClick: toggleInviteModalVisibility
                        }, {
                            circle: _withCtx(() => [
                                _hoisted_4
                            ]),
                            text: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('drawer_ending_button')), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    default: _withCtx(() => [
                        _createVNode(MemberDrawerItem, {
                            member: _unref(me),
                            flags: ['moderator']
                        }, null, 8, ["member"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invitedUnknownUsers), (u) => {
                            return (_openBlock(), _createBlock(MemberDrawerItem, {
                                key: u.email,
                                member: u,
                                flags: [],
                                status: _ctx.$t('not_in_workspace', { workspace: _unref(workspace).name })
                            }, {
                                trailing: _withCtx(() => [
                                    _createElementVNode("button", {
                                        onClick: ($event) => (handleRemoveInvitedUnknownUser(u))
                                    }, [
                                        _createVNode(SvgIcon, {
                                            name: "search-cross",
                                            class: "w-4 h-4 text-gray-300"
                                        })
                                    ], 8, _hoisted_2)
                                ]),
                                _: 2
                            }, 1032, ["member", "status"]));
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invitedUsers), (u) => {
                            return (_openBlock(), _createBlock(MemberDrawerItem, {
                                key: u.id,
                                member: u,
                                flags: [],
                                status: _ctx.$t('not_in_team')
                            }, {
                                trailing: _withCtx(() => [
                                    _createElementVNode("button", {
                                        onClick: ($event) => (handleRemoveInvitedUser(u))
                                    }, [
                                        _createVNode(SvgIcon, {
                                            name: "search-cross",
                                            class: "w-4 h-4 text-gray-300"
                                        })
                                    ], 8, _hoisted_3)
                                ]),
                                _: 2
                            }, 1032, ["member", "status"]));
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(singleTeamInvitations), (m) => {
                            return (_openBlock(), _createBlock(MemberDrawerItem, {
                                key: m.id,
                                member: m,
                                flags: [],
                                status: _ctx.$t('not_in_team')
                            }, {
                                trailing: _withCtx(() => [
                                    _createVNode(_component_CheckboxField, {
                                        "model-value": _unref(teamInvitations).includes(m),
                                        "onUpdate:modelValue": ($event) => (handleTeamInvitationChange(m))
                                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                                ]),
                                _: 2
                            }, 1032, ["member", "status"]));
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedMembers), (m) => {
                            return (_openBlock(), _createBlock(MemberDrawerItem, {
                                key: m.id,
                                member: m,
                                flags: []
                            }, {
                                trailing: _withCtx(() => [
                                    _createVNode(_component_CheckboxField, {
                                        "model-value": _unref(participantIds).has(m.id),
                                        "onUpdate:modelValue": ($event) => (handleParticipantChange(m.id))
                                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                                ]),
                                _: 2
                            }, 1032, ["member"]));
                        }), 128))
                    ], undefined, true),
                    _: 1
                }, 8, ["count", "title"]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('i_participate_text_1')), 1),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('i_participate_text_2')), 1)
                    ]),
                    _createVNode(_component_CheckboxField, {
                        class: "mt-2",
                        label: _ctx.$t('i_participate_checkbox'),
                        "model-value": _unref(moderatorParticipates),
                        "onUpdate:modelValue": handleModeradorParticipationChange
                    }, null, 8, ["label", "model-value"])
                ]),
                _createVNode(InvitesAndSeatsModal, {
                    modelValue: modalInvites.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((modalInvites).value = $event)),
                    "search-term": searchTerm.value,
                    "onUpdate:search-term": _cache[1] || (_cache[1] = ($event) => ((searchTerm).value = $event)),
                    "seats-to-buy": seatsToBuy.value,
                    "onUpdate:seats-to-buy": _cache[2] || (_cache[2] = ($event) => ((seatsToBuy).value = $event)),
                    "allow-discard-search-on-cancel": "",
                    "send-later": "",
                    variant: "team",
                    show: isInviteModalVisible.value,
                    users: _unref(restWorkspaceMembers),
                    workspace: _unref(workspace),
                    "is-loading": isLoading.value,
                    "pending-invites": _unref(pendingInvites),
                    onSend: handleSendInvites,
                    onCancel: handleCancelInvites
                }, null, 8, ["modelValue", "search-term", "seats-to-buy", "show", "users", "workspace", "is-loading", "pending-invites"])
            ]));
        };
    }
});
